/**
 * Public referral landing page — `/r/{CODE}`.
 *
 * Single job: extract the code from the URL, stash it in sessionStorage
 * (so a manual /signup deeplink later in the same tab still picks it
 * up), and redirect into /signup?ref=CODE. Anonymous, no auth.
 *
 * If the visitor is already logged in we send them to /invite instead
 * — they can't "be referred" a second time, so the friendly behaviour
 * is to land them on their own share page so they get the loop right
 * away. Their code from earlier is wiped from storage either way.
 */

import { auth } from '../auth.js';
import { navigate } from '../router.js';

const REFERRAL_STORAGE_KEY = 'triviana.referral_code';

export function renderReferralRedirect(root) {
  const parts = window.location.pathname.split('/').filter(Boolean);
  // /r/CODE → ['r', 'CODE']
  const code = (parts[1] || '').trim();

  // Already authed? Send them to their own invite hub. Drop any stale
  // stashed code so a re-login doesn't accidentally re-apply attribution
  // (the backend would also refuse, but stripping it client-side keeps
  // /me clean of one-time signup state).
  if (auth.isAuthenticated()) {
    try { sessionStorage.removeItem(REFERRAL_STORAGE_KEY); } catch { /* ignore */ }
    navigate('/invite');
    return;
  }

  if (code) {
    try { sessionStorage.setItem(REFERRAL_STORAGE_KEY, code); } catch { /* ignore */ }
  }

  // Render a tiny "Redirecting…" card so we don't flash white if the
  // navigate() below has any latency (popstate-driven re-render).
  root.innerHTML = `
    <div class="appbar">
      <div class="appbar-title">Triviana</div>
    </div>
    <div class="pad">
      <div class="card center" style="padding:24px;">
        <div style="font-family:var(--font-display);font-size:13px;letter-spacing:5px;color:#fff;margin-bottom:6px;">
          🎯 INVITED
        </div>
        <div class="muted" style="font-size:12.5px;">Taking you to sign up…</div>
      </div>
    </div>
  `;
  const dest = code ? `/signup?ref=${encodeURIComponent(code)}` : '/signup';
  // Use a real history.replaceState so the back button skips this stub.
  history.replaceState(null, '', dest);
  navigate(dest);
}
